$(document).ready(function () {
    console.log("Subscription Widget geladen");

    function formatMoney(amount) {
        return "€ " + Number(amount).toFixed(2).replace(".", ",");
    }

    function forceTwoDecimalsInSubscription() {
    $(".product-subscription .single-price, .product-subscription .bundle-price del, .product-subscription .subs-price del, .product-subscription .bundle-price .reg_price, .product-subscription .subs-price .reg_price").each(function () {
        let t = $(this).text();

        // nur wenn es wie ein Euro-Preis aussieht
        if (!t.includes("€")) return;

        // Zahl extrahieren (de-DE Komma erlaubt)
        let raw = t.replace("€", "").trim().replace(/\s+/g, "").replace(",", ".");
        let n = parseFloat(raw);
        if (isNaN(n)) return;

        // neu setzen: € 35,00
        $(this).text("€ " + n.toFixed(2).replace(".", ","));
    });
    }

    function initializeSubscriptionOptions() {
        $('#selling_plan_id').val('');
    }

    function updateSubscriptionPrice() {
        $(".product-subscription").each(function () {
            let productContainer = $(this),
                productPrice = parseFloat(
                    productContainer
                        .find(".single-price")
                        .data("base-price")
                );

            if (isNaN(productPrice) || productPrice <= 0) {
                console.warn("Produktpreis konnte nicht geladen werden.");
                return;
            }

            let bundleDiscount = 0.15,
                subscriptionDiscount = 0.15,
                bundlePrice = productPrice * 3 * (1 - bundleDiscount);
                subscriptionPrice = productPrice * (1 - subscriptionDiscount);

            productContainer
                .find(".bundle-price .reg_price")
                .text(formatMoney(bundlePrice));

            productContainer
                .find(".subs-price .reg_price")
                .text(formatMoney(subscriptionPrice));
        });
    }

    function updateCartQuantity() {
        $(".product-subscription").each(function () {
            let selectedOption = $(this)
                    .find('input[name="subscription"]:checked')
                    .val(),
                quantityInput = $(".quantity__input");

            selectedOption === "bundle"
                ? quantityInput.removeAttr("disabled").val(3)
                : quantityInput.attr("disabled", "disabled").val(1);
        });
    }

    function updateSellingPlanId() {
        $(".product-subscription").each(function () {
            let productContainer = $(this),
                oName = productContainer
                    .find('input[name="subscription"]:checked')
                    .val();

            console.log("oName " + oName);

            if (oName === "subscription") {
                let sellingPlanId = productContainer
                    .find(".selling_plan option:selected")
                    .val();

                sellingPlanId
                    ? ($("#selling_plan_id").val(sellingPlanId),
                      console.log("✅ selling_plan_id gesetzt:", sellingPlanId))
                    : console.error("❌ Fehler: selling_plan_id ist leer!");
            } else {
                $("#selling_plan_id").val("");
            }
        });
    }

    initializeSubscriptionOptions();
    updateSubscriptionPrice();
    forceTwoDecimalsInSubscription();

    $(".subscription-loading-overlay").fadeOut(300);

    $(".subscription-input, .selling_plan").on("change", function () {
        $(this)
            .closest(".subscription-item")
            .addClass("active")
            .siblings()
            .removeClass("active");

        updateCartQuantity();
        updateSellingPlanId();
        updateSubscriptionPrice();
        forceTwoDecimalsInSubscription();
    });

    $(document).on("variant:change", function () {
        initializeSubscriptionOptions();
        updateCartQuantity();
        updateSubscriptionPrice();
        updateSellingPlanId();
        forceTwoDecimalsInSubscription();
    });

    $("form[action='/cart/add']").on("submit", function () {
        updateCartQuantity();
        updateSellingPlanId();

        let sellingPlan = $("#selling_plan_id").val();
        console.log("🛒 Wird in den Warenkorb gesendet: selling_plan_id =", sellingPlan);
    });
});

//# sourceMappingURL=/s/files/1/0564/6263/9291/t/66/assets/script.js.map?v=1739972020